import axios from 'axios'
import qs from 'qs'
import config from './config-client'

axios.interceptors.request.use(config => {
    return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(response => response, error => Promise.resolve(error.response))

function checkStatus(response) {
    if (response.status === 200 || response.status === 304) {
        return response
    }
    return {
        data: {
            code: -404,
            message: response.statusText,
            data: ''
        }
    }
}

function checkCode(res) {
    if (res.status === -500) {
        window.location.href = '/backend'
    } else if (res.status === -400) {
        window.location.href = '/'
    } else if (res.status !== 200) {
        // createStore().dispatch('global/showMsg', res.data.message)
    }
    return res
}

export default {
    post(url, data) {
        return axios({
            method: 'post',
            url: config.api + url,
            data: data,
            timeout: config.timeout,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': window.localStorage.getItem("token")
            }
        }).then(checkStatus).then(checkCode)
    },
    welcomepost(url, data) {
        return axios({
            method: 'post',
            url: config.welcomeapi + url,
            data: data,
            timeout: config.timeout,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            }
        }).then(checkStatus).then(checkCode)
    },
    get(url, params) {
        return axios({
            method: 'get',
            url: config.api + url,
            params,
            timeout: config.timeout,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Authorization': window.localStorage.getItem("token")
            }
        }).then(checkStatus).then(checkCode)
    }
}



// WEBPACK FOOTER //
// ./src/api/index-client.js